import { createContext, useContext } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children, value }) => <AppContext.Provider value={value}>{children}</AppContext.Provider>;

export const useAppContext = () => useContext(AppContext);

export default AppContext;
